/* global axios */
import ApiClient from './ApiClient';

// Métricas da IA a nível de conta (resource singular: GET .../ai_agent_metrics).
class AiAgentMetricsAPI extends ApiClient {
  constructor() {
    super('ai_agent_metrics', { accountScoped: true });
  }

  // SiteUp (operacao): aceita period (today/7d/30d/all) e inbox_id.
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // SiteUp (operacao): kill switch — pausa/retoma a IA da conta inteira.
  togglePause(paused) {
    return axios.post(`${this.url}/toggle_pause`, { paused });
  }

  // SiteUp (operacao): health-check do motor de IA (1 completion mínima).
  engineHealth() {
    return axios.post(`${this.url}/engine_health`);
  }

  // SiteUp (Copiloto): follow-ups da IA (agendados / em andamento / fila).
  followUps() {
    return axios.get(`${this.url}/follow_ups`);
  }
}

export default new AiAgentMetricsAPI();
